import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ChevronLeft, CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F2547] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <h1 className="font-heading text-2xl font-bold text-[#0F2547] mb-2">Reset your password</h1>
        {sent ? (
          <div data-testid="forgot-password-confirmation">
            <div className="flex items-start gap-3 rounded-lg bg-emerald-50 border border-emerald-200 px-4 py-4 my-4">
              <CheckCircle2 className="h-5 w-5 text-[#007F3B] mt-0.5" />
              <p className="text-sm text-slate-700">If that email is registered, a reset link has been sent. The link expires in 1 hour.</p>
            </div>
            <Link to="/staff/login" className="text-sm font-semibold text-[#005EB8] hover:underline" data-testid="back-to-signin-link">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-password-form">
            <p className="text-sm text-slate-500 mb-6">Enter your staff email and we'll send you a reset link.</p>
            {error && <div className="mb-4 rounded-lg bg-red-50 border border-red-200 text-[#D5281B] text-sm px-4 py-3" data-testid="forgot-password-error">{error}</div>}
            <div className="relative mb-6">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <input
                data-testid="forgot-password-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-12 rounded-lg border border-slate-300 pl-10 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#005EB8]"
                placeholder="you@waleseventmedical.co.uk"
              />
            </div>
            <button
              data-testid="forgot-password-submit-button"
              type="submit"
              disabled={loading}
              className="w-full h-12 rounded-lg bg-[#005EB8] hover:bg-[#004a93] transition-colors text-white font-semibold text-sm disabled:opacity-60 mb-4"
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>
            <Link to="/staff/login" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-[#005EB8]" data-testid="back-to-signin-link">
              <ChevronLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
